import * as React from "react"
import { badgeVariants, type BadgeVariantProps } from "./badgeVariants"
import { cn } from "@/lib/utils"

/** Props para o componente Badge */
export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    BadgeVariantProps {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

// Exportamos apenas o componente para satisfazer 'only-export-components'
export { Badge }
